<style>
    .selectSociety {
        width: 100% !important;
        /* max-width: fit-content; */
    }
</style>
<template>
  <div>

    <!-- Form Modal -->
    <b-modal
      id="modal-season-form"
      ref="myModalTransport"
      centered
      no-close-on-backdrop
      no-close-on-esc
      size="lg"
      @ok="submitTransports"
    >
      <!-- Custom Modal Header -->
      <template #modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->
        <!-- <h5>Add Transports</h5> -->
        <h5 v-if="long_haul.id === null">
          Register Transports
        </h5>
        <h5 v-if="long_haul.id !== null">
          Edit Transports
        </h5>

        <feather-icon
          class="ml-4 pr-0 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="close()"
        />
      </template>

      <!-- Custom Modal Footer -->
      <template #modal-footer="{ ok, cancel }">
        <b-button
          size="sm"
          variant="primary"
          :disabled="saving"
          @click="ok()"
        >
          <b-spinner
            v-if="saving"
            small
            class="mr-1"
            label="Small Spinner"
          />
          <span v-if="!saving">Save</span>
          <span v-if="saving">Saving...</span>
        </b-button>
        <b-button
          size="sm"
          variant="outline-secondary"
          @click="cancel()"
        >
          Cancel
        </b-button>
      </template>

      <!-- Data Form in Modal Body -->
      <template #default="{ }">
        <validation-observer
          ref="dataForm"
          #default="{ invalid }"
        >
          <b-form
            ref="form"
            @submit.stop.prevent="handleCreateFleet"
          >
            <b-row>
              <b-col cols="6">
                <b-form-group
                  label-for="transporter_id"
                  label="Transporter"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="transporter_id"
                    rules=""
                  >
                    <Dropdown
                      id="transporter_id"
                      v-model="long_haul.transporter_id"
                      name="transporter_id"
                      size="sm"
                      :options="transporters"
                      filter
                      option-label="name"
                      option-value="id"
                      placeholder="Select..."
                      class="w-full md:w-14rem selectSociety"
                      @change="changeFormSelection(long_haul.transporter_id)"
                    >
                      <template #option="slotProps">
                        <div class="flex align-items-center">
                          <div>{{ slotProps.option.name }} ({{ slotProps.option.code }})</div>
                        </div>
                      </template>
                    </Dropdown>
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small
                      v-if="serverErrors && serverErrors.transporter_id"
                      class="text-danger"
                    >{{ serverErrors.transporter_id[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group
                  label-for="driver_id"
                  label="Driver"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="driver_id"
                    rules=""
                  >
                    <Dropdown
                      id="driver_id"
                      v-model="long_haul.driver_id"
                      name="driver_id"
                      size="sm"
                      :options="transporterDrivers"
                      filter
                      option-label="name"
                      option-value="id"
                      placeholder="Select..."
                      class="w-full md:w-14rem selectSociety"
                    >
                      <template #option="slotProps">
                        <div class="flex align-items-center">
                          <div>{{ slotProps.option.name }}</div>
                        </div>
                      </template>
                    </Dropdown>
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small
                      v-if="serverErrors && serverErrors.driver_id"
                      class="text-danger"
                    >{{ serverErrors.driver_id[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="6">
                <b-form-group
                  label-for="truck_id"
                  label="Truck"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="truck_id"
                    rules=""
                  >
                    <Dropdown
                      id="truck_id"
                      v-model="long_haul.truck_id"
                      name="truck_id"
                      size="sm"
                      :options="fleets"
                      filter
                      option-label="name"
                      option-value="id"
                      placeholder="Select..."
                      class="w-full md:w-14rem selectSociety"
                    >
                      <template #option="slotProps">
                        <div class="flex align-items-center">
                          <div>{{ slotProps.option.name }}</div>
                        </div>
                      </template>
                    </Dropdown>
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small
                      v-if="serverErrors && serverErrors.truck_id"
                      class="text-danger"
                    >{{ serverErrors.truck_id[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group
                  label-for="trailer_id"
                  label="Trailer"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="truck_id"
                    rules=""
                  >
                    <Dropdown
                      id="trailer_id"
                      v-model="long_haul.trailer_id"
                      name="trailer_id"
                      size="sm"
                      :options="trailers"
                      filter
                      option-label="name"
                      option-value="id"
                      placeholder="Select..."
                      class="w-full md:w-14rem selectSociety"
                    >
                      <template #option="slotProps">
                        <div class="flex align-items-center">
                          <div>{{ slotProps.option.name }}</div>
                        </div>
                      </template>
                    </Dropdown>
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small
                      v-if="serverErrors && serverErrors.trailer_id"
                      class="text-danger"
                    >{{ serverErrors.trailer_id[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <!-- <b-row v-if="long_haul.sourceType == 1"> -->
            <b-row>
              <b-col cols="6">
                <b-form-group
                  label-for="source_id"
                  label="Source PS"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="source_id"
                    rules=""
                  >
                    <Dropdown
                      id="source_id"
                      v-model="long_haul.source_id"
                      name="source_id"
                      size="sm"
                      :options="societies"
                      filter
                      option-label="name"
                      option-value="id"
                      placeholder="Select..."
                      class="w-full md:w-14rem selectSociety"
                      @change="changeSource(long_haul.source_id)"
                    >
                      <template #option="slotProps">
                        <div class="flex align-items-center">
                          <div>{{ slotProps.option.name }} ({{ slotProps.option.code }})</div>
                        </div>
                      </template>
                    </Dropdown>
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small
                      v-if="serverErrors && serverErrors.source_id"
                      class="text-danger"
                    >{{ serverErrors.source_id[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col
                cols="12"
                md="4"
              >
                <b-form-group
                  label-for="destination_id"
                  label="Destination"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="destination_id"
                    rules=""
                  >
                    <Dropdown
                      id="destination_id"
                      v-model="long_haul.destination_id"
                      name="destination_id"
                      size="sm"
                      :options="destinations"
                      filter
                      option-label="name"
                      option-value="id"
                      placeholder="Select..."
                      class="w-full md:w-14rem selectSociety"
                      @change="changeDestination()"
                    >
                      <template #option="slotProps">
                        <div class="flex align-items-center">
                          <div>{{ slotProps.option.name }}</div>
                        </div>
                      </template>
                    </Dropdown>
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small
                      v-if="serverErrors && serverErrors.destination_id"
                      class="text-danger"
                    >{{ serverErrors.destination_id[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col
                cols="12"
                md="2"
              >
                <b-form-group
                  label-for="sale_id"
                  label="Sale #"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="sale_id"
                    rules=""
                  >
                    <Dropdown
                      id="sale_id"
                      v-model="long_haul.sale_id"
                      name="sale_id"
                      size="sm"
                      :options="sales"
                      filter
                      option-label="name"
                      option-value="id"
                      placeholder="Select..."
                      class="w-full md:w-14rem selectSociety"
                    >
                      <template #option="slotProps">
                        <div class="flex align-items-center">
                          <div>{{ slotProps.option.name }}</div>
                        </div>
                      </template>
                    </Dropdown>
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small
                      v-if="serverErrors && serverErrors.sale_id"
                      class="text-danger"
                    >{{ serverErrors.sale_id[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col cols="6">
                <b-form-group
                  label-for="orderNumber"
                  label="Order Number"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="orderNumber"
                    rules="required"
                  >
                    <b-form-input
                      id="orderNumber"
                      v-model="long_haul.orderNumber"
                      name="orderNumber"
                      size="sm"
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small
                      v-if="serverErrors && serverErrors.orderNumber"
                      class="text-danger"
                    >{{ serverErrors.orderNumber[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>

              <b-col cols="6">
                <b-form-group
                  label-for="number"
                  label="TF number "
                >
                  <validation-provider
                    #default="{ errors }"
                    name="number"
                    rules=""
                  >
                    <b-form-input
                      id="number"
                      v-model="long_haul.number"
                      name="number"
                      size="sm"
                      :state="errors.length > 0 ? false : null"
                      disabled
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                    <small
                      v-if="serverErrors && serverErrors.number"
                      class="text-danger"
                    >{{ serverErrors.number[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col class="move-right">
                <b-button
                  size="sm"
                  class="mb-1"
                  variant="outline-primary"
                  @click="addElement()"
                >
                  Add Seal
                </b-button>
              </b-col>
            </b-row>

            <b-row>

              <table class="table">
                <thead>
                  <tr class="text-center">
                    <th>Seal Number</th>
                    <th width="3%" />
                  </tr>
                </thead>
                <tbody>

                  <tr
                    v-for="seal, index in long_haul.seals"
                    :key="index"
                  >
                    <td scope="row">
                      <div>
                        <b-form-input
                          id="share"
                          v-model="long_haul.seals[index].number"
                          name="start"
                          size="sm"
                        />
                      </div>
                    </td>
                    <td>
                      <b-button
                        variant="outline-danger"
                        size="sm"
                        @click="removeRow(index)"
                      >
                        <feather-icon
                          icon="TrashIcon"
                          size="11"
                          class="text-danger stroke-current"
                        />
                      </b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-row>
          </b-form>
        </validation-observer>
      </template>
    </b-modal>
    <!-- ./Form Modal -->

    <!-- Form Modal -->
    <b-modal
      ref="myModalTicket"
      centered
      no-close-on-backdrop
      no-close-on-esc
      :hide-footer="true"
      size="lg"
    >
      <!-- Custom Modal Header -->
      <template #modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->
        <h5>Transports Tickets</h5>
        <feather-icon
          class="ml-4 pr-0 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="close()"
        />
      </template>

      <!-- Data Form in Modal Body -->
      <template #default="{ }">
        <b-row>
          <b-col cols="4">
            <label>Transportation type: <strong>{{ tfDetails.transaction.code }}</strong></label>
          </b-col>
          <b-col cols="4">
            <label>TF Number: <strong>{{ tfDetails.tfNumber }}</strong></label>
          </b-col>
          <b-col cols="4">
            <label>Source Warehouse: <strong>{{ tfDetails.routes.sourceName }}</strong></label>
          </b-col>
        </b-row>

        <b-row class="mb-10">
          <b-col cols="4">
            <label>Destination Warehouse: <strong>{{ tfDetails.routes.destinationName }}</strong></label>
          </b-col>
          <b-col cols="4">
            <label>Driver Licence: <strong>{{ tfDetails.drivers.licence }}</strong></label>
          </b-col>
          <b-col cols="4">
            <label>Plate Number: <strong>{{ tfDetails.fleets[0].plateNumber }}</strong></label>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="4">
            <label>Order Number: <strong>{{ tfDetails.orderNumber }}</strong></label>
          </b-col>
          <b-col cols="4">
            <label>Local TF Number: <strong>{{ tfDetails.number }}</strong></label>
          </b-col>
          <b-col
            v-if="tfDetails.seals.length > 0"
            cols="4"
          >
            <label>Seals</label>
            <br>
            <a
              v-for="seal in tfDetails.seals"
              href="#"
              class="badge badge-primary ml-1"
            >{{ seal.number }}</a>
          </b-col>
        </b-row>

        <div style="max-height: 400px; overflow-y: auto;">
          <table
            class="table mt-10"
            style="margin-top: 20px;"
          >
            <thead>
              <tr>
                <th scope="col">
                  SN
                </th>
                <th scope="col">
                  Barcode
                </th>
                <th scope="col">
                  NGrade
                </th>
                <th
                  scope="col"
                  class="text-center"
                >
                  R/Weight
                </th>
                <th
                  v-if="tfDetails.transaction.code == 'RT' || tfDetails.transaction.code == 'RH'"
                  scope="col"
                  class="text-center"
                >
                  D/Weight
                </th>
                <th scope="col">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(tiket, index) in tikets">
                <th scope="row">
                  {{ index + 1 }}
                </th>
                <td>{{ tiket.barcode }}</td>
                <td>{{ tiket.ngrade }}</td>
                <td class="text-center">
                  {{ tiket.massReceived }}
                </td>
                <td
                  v-if="tfDetails.transaction.code == 'RT' || tfDetails.transaction.code == 'RH'"
                  class="text-center"
                >
                  {{ tiket.massDispatched }}
                </td>
                <td>
                  <b-button
                    variant="outline-danger"
                    size="sm"
                    @click="confirmDeleteTicket(tiket.id)"
                  >
                    <feather-icon
                      icon="TrashIcon"
                      size="11"
                      class="text-danger stroke-current"
                    />
                  </b-button>
                </td>
              </tr>
            </tbody>

            <tfoot>
              <tr style="font-weight:bold;">
                <td class="footer">
                  Total Bales:
                </td>
                <td class="footer">
                  {{ tikets.length }}
                </td>
                <td class="footer">
&nbsp;
                </td>
                <td class="footer">
                  Total Mass:{{ totalWeight.toFixed(3) }}
                </td>
                <td
                  v-if="tfDetails.transaction.code == 'RT' || tfDetails.transaction.code == 'RH'"
                  class="footer"
                >
                  {{ tValue.toFixed(3) }}
                </td>
              </tr>
            </tfoot>

          </table>
        </div>

        <!-- <b-row style="font-weight:bold;">
                    <b-col cols="6" class="float-right">
                        <label>Total Bales: <strong>{{ tikets.length }}</strong></label>
                    </b-col>
                    <b-col cols="6" class="float-left">
                        <label>Total Mass: <strong>{{ totalWeight.toFixed(3) }}</strong></label>
                    </b-col>
                </b-row> -->
      </template>
    </b-modal>
    <!-- ./Form Modal -->

    <!-- Filters -->
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5>Filters</h5>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col
            cols="6"
            md="3"
          >
            <b-form-group
              label-for="from_id"
              label="From"
            >
              <validation-provider
                #default="{ errors }"
                name="from_id"
                rules=""
              >
                <b-form-select
                  id="from_id"
                  name="from_id"
                  size="sm"
                  @change=""
                >
                  <b-form-select-option :value="null">
                    -- Select --
                  </b-form-select-option>
                </b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
                <small
                  v-if="serverErrors && serverErrors.from_id"
                  class="text-danger"
                >{{ serverErrors.from_id[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- <b-card>{{ file }}</b-card> -->
      </b-card-body>
    </b-card>
    <!-- ./Filters -->

    <b-card
      no-body
      class="mb-0"
    >
      <div class="m-2">
        <!-- Table Top -->
        <b-row>
          <!-- Per Page -->
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <label>Show</label>
            <v-select
              v-model="perPage"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :options="perPageOptions"
              :clearable="false"
              class="per-page-selector d-inline-block mx-50 select-size-sm"
            />
            <label>entries</label>

            <b-button
              variant="outline-success"
              size="sm"
              class="ml-2"
              @click="generateReport()"
            >
              <b-spinner
                v-if="saving"
                small
                class="ml-1"
                label="Small Spinner"
              />
              <span class="text-nowrap">Generate Data</span>
              <feather-icon
                icon="DownloadCloudIcon"
                class="ml-1"
              />
            </b-button>
          </b-col>
          <!-- ./Per Page -->

          <!-- Search & Button -->
          <b-col
            cols="12"
            md="6"
          >
            <p>Weight: {{ weight }}</p>
            <div class="d-flex align-items-center justify-content-end">
              <b-form-input
                v-model="searchQuery"
                class="d-inline-block mr-1"
                placeholder="Search..."
                size="sm"
              />
              <b-button
                variant="primary"
                size="sm"
                @click="invokeFleetsForm()"
              >
                <span class="text-nowrap">Add Transports</span>
              </b-button>
              <!-- <b-button variant="info" class="ml-2" size="md" @click="requestDevice()">
                                <span class="text-nowrap">Connect to bluetooth</span>
                            </b-button> -->
            </div>
          </b-col>
          <!-- ./Search & Button-->
        </b-row>
        <!-- ./Table Top -->
      </div>

      <!-- Table -->
      <b-table
        ref="records"
        striped
        hover
        small
        class="position-relative"
        :items="fetch"
        responsive
        :fields="columns"
        primary-key="id"
        :sort-by.sync="sortBy"
        show-empty
        empty-text="No records found"
        :sort-desc.sync="isSortDirDesc"
      >

        <template #cell(check)="data">
          <b-form-checkbox
            class="custom-control-success"
            :checked="isItemSelected(data.item.id)"
            @change="checkboxToggled(data.item, $event)"
          />
        </template>

        <template #cell(transporter)="data">
          {{ data.item.transporter.name }}
        </template>
        <template #cell(driver)="data">
          {{ data.item.drivers.fullName.toUpperCase() }}
        </template>
        <template #cell(mobile)="data">
          {{ data.item.drivers.mobile }}
        </template>

        <template #cell(fleets)="data">
          <!-- {{ data.item.fleets[0].make }} - {{ data.item.fleets[0].plateNumber }} -->
          <span v-if="data.item.fleets.length > 1">
            {{ data.item.fleets[0].plateNumber }}/{{ data.item.fleets[1].plateNumber }}
          </span>
          <span v-if="data.item.fleets.length == 1">
            {{ data.item.fleets[0].plateNumber }}
          </span>
        </template>

        <template #cell(source)="data">
          {{ data.item.routes.sourceName }}
        </template>

        <template #cell(destination)="data">
          {{ data.item.routes.destinationName }}
        </template>

        <template #cell(sale)="data">
          <span v-if="data.item.sale != null">{{ data.item.sale.number }}</span>
          <span v-else />
        </template>

        <template #cell(loading_date)="data">
          <span class="text-nowrap">
            {{ data.item.loading_date | moment('DD/MM/YYYY') }}
          </span>
        </template>

        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item @click="invokeUpdateForm(data.item)">
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>

            <b-dropdown-item @click="printPdf(data.item)">
              <feather-icon icon="PrinterIcon" />
              <span class="align-middle ml-50">Print</span>
            </b-dropdown-item>
            <b-dropdown-item @click="viewTickets(data.item)">
              <feather-icon icon="EyeIcon" />
              <span class="align-middle ml-50">View Tickets</span>
            </b-dropdown-item>
            <b-dropdown-item @click="confirmDelete(data.item.id)">
              <feather-icon icon="TrashIcon" />
              <span class="align-middle ml-50">Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>

      <!-- Table Footer -->
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing {{ from }} to {{ to }} of {{ totalRecords }} entries</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
          >
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRecords"
              :per-page="perPage"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
    BRow, BCol, BCard, BCardHeader, BCardBody, BTable, BPagination,
    BForm, BFormGroup,
    BButton, BFormSelect, BFormSelectOption, BFormInput, BDropdown, BDropdownItem,
    BSpinner, BFormCheckbox,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { required } from '@validations'
import store from '@/store'
import { ref, onUnmounted, onMounted } from '@vue/composition-api'
import shortHaulsStoreModule from '@/views/cromis/green_shipping/short_haul/shortHaulsStoreModule'
import useShortHaulsList from '@/views/cromis/green_shipping/short_haul/useShortHaulsList'
import Dropdown from 'primevue/dropdown'
import { useBluetooth } from '@vueuse/core'
import axios from '@axios'
import moment from 'moment'

export default {
    components: {
        BRow,
        BCol,
        BCard,
        BCardHeader,
        BCardBody,
        BTable,
        BPagination,
        BForm,
        BFormGroup,
        BButton,
        BFormSelect,
        BFormSelectOption,
        BFormInput,
        vSelect,
        BDropdown,
        BDropdownItem,
        BSpinner,
        ValidationObserver,
        ValidationProvider,
        BFormCheckbox,
        Dropdown,
    },
    directives: {},
    props: {},
    setup(props, context) {
        const dataForm = ref(null)
        const myModal = ref(null)
        const myModalTransport = ref(null)
        const myModalTicket = ref(null)
        const saving = ref(false)
        const serverErrors = ref(null)
        const selections = ref([])
        const formSelections = ref([])
        const levels = ref(null)
        const children = ref([])
        const transporters = ref([])
        const drivers = ref([])
        const transports = ref([])
        const transporterDrivers = ref([])
        const bestRoute = ref()
        const fleets = ref([])
        const trailers = ref([])
        const routes = ref([])
        const warehouses = ref([])
        const markets = ref([])
        const destinations = ref([])
        const sales = ref([])
        const selectedCompany = ref(null)
        const societies = ref([])
        const tikets = ref([])
        const tfDetails = ref([])
        const totalWeight = ref(0)
        const tValue = ref(0)
        const selectedDriver = ref()
        const weight = ref(null)
        const device = ref(null)
        const allChecked = ref(false)
        const agreeIds = ref([])
        const selectedRows = ref([])
        const selectedItems = ref([])

        const transporter = ref({
            id: null,
            company_id: null,
            tin: null,
            name: null,
            vrn: null,
            busines_licence: null,
        })

        const long_haul = ref({
            id: null,
            truck_id: null,
            trailer_id: null,
            route_id: null,
            source_id: null,
            destination_id: null,
            sale_id: null,
            gender: null,
            isShortHaul: null,
            transporter_id: null,
            driver_id: null,
            sourceType: 1,
            orderNumber: null,
            number: null,
            seals: [
                { number: null },
            ],
        })

        const CROMIS_STORE_MODULE_NAME = 'cromis-short_haul'

        // Register module
        if (!store.hasModule(CROMIS_STORE_MODULE_NAME)) store.registerModule(CROMIS_STORE_MODULE_NAME, shortHaulsStoreModule)

        // UnRegister on leave
        onUnmounted(() => {
            if (store.hasModule(CROMIS_STORE_MODULE_NAME)) store.unregisterModule(CROMIS_STORE_MODULE_NAME)
        })

        onMounted(async () => {
            await store.dispatch('cromis-short_haul/transporters')
                .then(response => {
                    transporters.value = response.data.transporters
                    transporters.value = transporters.value.sort((a, b) => a.name.localeCompare(b.name))
                })
                .catch(error => {
                    console.log('got error', error)
                })

            const str = window.location.href
            let shotHaul
            if (str[3] == 'long_haul') {
                shotHaul = false
            } else {
                shotHaul = true
            }

            if (shotHaul) {
                transports.value = null

                await store.dispatch('cromis-short_haul/shortList')
                    .then(response => {
                        transports.value = response.data.transports
                    })
                    .catch(error => {
                        console.log('got error', error)
                    })
            } else {
                transports.value = null
                await store.dispatch('cromis-short_haul/list')
                    .then(response => {
                        transports.value = response.data.transports
                    })
                    .catch(error => {
                        console.log('got error', error)
                    })
            }

            await store.dispatch('cromis-short_haul/markets')
                .then(response => {
                    markets.value = response.data.markets
                })
                .catch(error => {
                    console.log('got error', error)
                })

            await store.dispatch('cromis-short_haul/routes')
                .then(response => {
                    routes.value = response.data.routes
                    // console.log(routes.value)
                })
                .catch(error => {
                    console.log('got error', error)
                })

            await store.dispatch('cromis-short_haul/societies')
                .then(response => {
                    societies.value = response.data.societies
                    societies.value = societies.value.sort((a, b) => a.name.toUpperCase().localeCompare(b.name.toUpperCase()))
                })
                .catch(error => {
                    console.log('got error', error)
                })
        })

        const addElement = () => {
            long_haul.value.seals.push({ number: '' })

            if (long_haul.value.seals.length > 0) {
                // console.log(long_haul.value.seals)
            }
        }

        const removeRow = index => {
            if (long_haul.value.seals.length > 1) {
                long_haul.value.seals.splice(index, 1)
                long_haul.value.seals = long_haul.value.seals
            }
        }

        const toggleCheckAll = isChecked => {
            if (isChecked) {
                // Assuming `records` is an array of item objects
                selectedItems.value = records.value.map(item => item.id) // Replace 'id' with your unique identifier
            } else {
                selectedItems.value = []
            }
        }

        const isItemSelected = itemId => selectedItems.value.includes(itemId)

        const checkboxToggled = async (item, event) => {
            if (event) {
                if (!agreeIds.value.includes(item.id)) {
                    agreeIds.value.push(item.id)
                }
            } else {
                agreeIds.value = agreeIds.value.filter(id => id !== item.id)
            }
        }

        const generateReport = async () => {
            const payload = {
                ids: agreeIds.value,
            }
            await store.dispatch('cromis-short_haul/regenerate', payload)
                .then(response => {
                    refetch()
                    saving.value = false

                    context.root.$swal({
                        icon: 'success',
                        text: 'Regenerate File has been initialized successfully!',
                        showConfirmButton: true,
                        timer: 3000,
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch(error => {
                    saving.value = false
                    console.log(error)
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data.errors
                    } else {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const requestDevice = async () => {
            try {
                const device = await navigator.bluetooth.requestDevice({
                    acceptAllDevices: true,
                })
                const server = await device.gatt.connect()

                // Connect to the Bluetooth device
                // const device = await Bluetooth.connect('etJ0wA1bAl4D1hkE6CBMkw==');

                // Send command to request weight data
                // await device.sendCommand('get_weight');

                // Receive data from the device
                const data = await device.receiveData()

                // Process data to extract weight value
                this.weight = this.parseWeightData(data)

                // Close the connection
                await device.close()
            } catch (error) {
                console.error('Failed to connect to device', error)
            }
        }

        const parseWeightData = async () => JSON.parse(data).weight

        const changeFormSelection = async transporter_id => {
            const transporter = transporters.value.filter(e => e.id == transporter_id)[0]

            transporter.fleets.forEach(ele => {
                if (ele.isTrailer == 0) {
                    fleets.value.push({
                        ...ele,
                        name: ele.plateNumber,
                    })
                }
            })

            transporter.fleets.forEach(ele => {
                if (ele.isTrailer == 1) {
                    trailers.value.push({
                        ...ele,
                        name: ele.plateNumber,
                    })
                }
            })

            await store.dispatch('cromis-short_haul/transportDriver', { transporter })
                .then(response => {
                    transporterDrivers.value = response.data

                    transporterDrivers.value = transporterDrivers.value.map(driver => ({
                        ...driver,
                        name: driver.person.middleName !== null ? `${driver.person.firstName} ${driver.person.middleName} ${driver.person.lastName} (${driver.license})` : `${driver.person.firstName} ${driver.person.lastName} (${driver.license})`,
                    }))

                    // console.log(transporterDrivers.value)
                })
                .catch(error => {
                    console.log('got error', error)
                })
        }

        const changeSource = async source => {
            await store.dispatch('cromis-short_haul/route_dest', source)
                .then(response => {
                    destinations.value = response.data.warehouses
                })
                .catch(error => {
                    console.log('got error', error)
                })

            changeDestination()
        }

        const changeDestination = async () => {
            if (long_haul.value.source_id == null || long_haul.value.destination_id == null) {
                sales.value.splice(0)
            } else {
                await store.dispatch('cromis-short_haul/sales', { society_id: long_haul.value.source_id, market_id: long_haul.value.destination_id })
                    .then(response => {
                        sales.value = response.data.sales.map(sale => ({
                            ...sale,
                            name: sale.number,
                        }))

                        sales.value = [{ id: null, number: null, name: 'Select --' }, ...sales.value]
                    })
                    .catch(error => {
                        console.log('got error', error)
                    })
            }
        }

        const findRoute = async (source, dest) => {
            // console.log(source)
            const route = {
                source,
                dest,
            }
            await store.dispatch('cromis-short_haul/find_route', { route })
                .then(response => {
                    bestRoute.value = response.data.id
                    // console.log(response.data)
                })
                .catch(error => {
                    console.log('got error', error)
                })
        }

        const {
            fetch,
            columns,
            perPage,
            currentPage,
            totalRecords,
            from,
            to,
            meta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            records,
            refetch,

            // Filers
            locationFilter,
        } = useShortHaulsList()

        const viewTickets = item => {
            tfDetails.value = item
            tikets.value = item.tickets
            // console.log(tfDetails)
            totalWeight.value = 0.000
            tValue.value = 0.000

            for (let index = 0; index < tikets.value.length; index++) {
                totalWeight.value += parseFloat(tikets.value[index].massReceived)
                tValue.value += parseFloat(tikets.value[index].massDispatched)
            }

            myModalTicket.value.show()
        }
        // Form Methods
        const invokeUpdateForm = item => {
            // console.log(item)

            serverErrors.value = null

            const trans = transporters.value.find(obj => obj.id === item.drivers.transporter_id)
            changeFormSelection(trans.id)
            changeSource(item.routes.sourceId)

            long_haul.value = {
                id: item.id,
                transporter_id: trans.id,
                truck_id: item.truck_id,
                trailer_id: item.trailer_id,
                route_id: 0,
                driver_id: item.driver_id,
                source_id: item.routes.sourceId,
                sourceType: 1,
                destination_id: item.routes.destinationId,
                sale_id: item.sale_id,
                isShortHaul: true,
                orderNumber: item.orderNumber,
                number: item.number,
                seals: item.seals,
            }

            changeDestination()

            myModalTransport.value.show()
        }

        const invokeFleetsForm = () => {
            serverErrors.value = null
            let str = window.location.href
            let shotHaul
            str = str.split('/')
            if (str[3] == 'long_haul') {
                shotHaul = false
            } else {
                shotHaul = true
            }

            long_haul.value = {
                id: null,
                truck_id: null,
                trailer_id: null,
                route_id: 0,
                source_id: null,
                destination_id: null,
                sale_id: null,
                isShortHaul: shotHaul,
                transporter_id: null,
                driver_id: null,
                sourceType: 1,
                orderNumber: null,
                number: null,
                seals: [
                    { number: null },
                ],
            }
            myModalTransport.value.show()
        }

        const invokeCreateForm = () => {
            formSelections.value.map(form => {
                form.model = null
            })

            myModal.value.show()
        }

        const isFormValid = async () => {
            let isValid = false
            await dataForm.value.validate().then(success => {
                isValid = success
            })

            return isValid
        }

        const submit = bvModalEvt => {
            bvModalEvt.preventDefault()

            serverErrors.value = null
            // Handle form submit
            if (transporter.value.id === null || transporter.value.id === 0) handleCreate()
            else handleUpdate(sector.value)
        }

        const handleCreate = async () => {
            saving.value = true
            const valid = await isFormValid()

            if (!valid) {
                saving.value = false
            }
        }

        const submitTransports = bvModalEvt => {
            // console.log(long_haul.value)
            bvModalEvt.preventDefault()

            serverErrors.value = null
            // handelDriverCreate()

            if (long_haul.value.id === null || long_haul.value.id === 0) handelDriverCreate()
            else handleUpdate(long_haul.value)
        }
        const handleUpdate = async item => {
            // long_haul.value.transporter_id = long_haul.transporter_id
            saving.value = true
            const valid = await isFormValid()
            // console.log(item)
            if (!valid) {
                saving.value = false
                return
            }

            await store.dispatch('cromis-short_haul/update', { id: item.id, data: item })
                .then(response => {
                    // console.log(response)
                    refetch()
                    saving.value = false

                    myModalTransport.value.hide()

                    context.root.$swal({
                        icon: 'success',
                        text: 'Changes to Transports has been saved successfully!',
                        showConfirmButton: true,
                        timer: 3000,
                        customClass: {
                            confirmButton: 'btn btn-success',
                        },
                        buttonsStyling: false,
                    })
                })
                .catch(error => {
                    saving.value = false
                    console.log(error)
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data.errors
                    } else {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const handelDriverCreate = async () => {
            saving.value = true
            const valid = await isFormValid()

            if (!valid) {
                saving.value = false
                return
            }
            long_haul.value.route_id = bestRoute

            // if (long_haul.value.isShortHaul == true) {
            //     long_haul.value.destination_id = long_haul.value.source_id
            //     long_haul.value.route_id = 0
            //     long_haul.value.source_id = null
            // }

            // console.log(long_haul.value)

            await store.dispatch('cromis-short_haul/create', long_haul.value)
                .then(response => {
                    refetch()
                    saving.value = false

                    context.root.$swal({
                        icon: 'success',
                        text: 'The transport has been added successfully!',
                        showConfirmButton: true,
                        timer: 5000,
                        customClass: {
                            confirmButton: 'btn btn-primary',
                        },
                        buttonsStyling: false,
                    })
                    long_haul.value = {
                        id: null,
                        license: null,
                        firstName: null,
                        lastName: null,
                        middleName: null,
                        gender: null,
                        transporter_id: null,
                        sourceType: 1,
                        destination_id: null,
                        orderNumber: null,
                        number: null,
                    }
                    myModalTransport.value.hide()
                })
                .catch(error => {
                    console.log(error)
                    saving.value = false
                    if (error.response.status === 422) {
                        serverErrors.value = error.response.data.errors
                    } else {
                        context.root.$swal({
                            icon: 'error',
                            title: 'Server Error',
                            text: 'Something went wrong. See tech support',
                            showConfirmButton: true,
                            customClass: {
                                confirmButton: 'btn btn-danger',
                            },
                            buttonsStyling: false,
                        })
                    }
                })
        }

        const printPdf = async tf => {
            // console.log(tf)

            window.open(`${axios.defaults.baseURL}/reports/print_transport?id=${tf.id}`, '_blank')
        }

        const confirmDelete = async id => {
            const result = context.root.$swal({
                icon: 'info',
                title: 'System Info',
                text: 'Are you sure you want to delete the this TF?',
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, cancel',
                customClass: {
                    confirmButton: 'btn btn-info',
                    cancelButton: 'btn btn-danger ml-2', // Optional: Customize the cancel button class
                },
                buttonsStyling: true,
            }).then(result => {
                if (result.value) {
                    remove(id)
                } else {
                    context.root.$swal({
                        icon: 'info',
                        title: 'Cancelled',
                        text: 'Your TF is safe you cancell deletion of it',
                        showConfirmButton: true,
                        customClass: {
                            confirmButton: 'btn btn-info',
                        },
                        buttonsStyling: true,
                    })
                }
            })
        }

        const remove = async id => {
            await store.dispatch('cromis-short_haul/remove', id)
                .then(response => {
                    refetch()
                })
                .catch(error => {
                    context.root.$swal({
                        icon: 'error',
                        title: 'Server Error',
                        text: 'Something went wrong. See tech support',
                        showConfirmButton: true,
                        customClass: {
                            confirmButton: 'btn btn-danger',
                        },
                        buttonsStyling: true,
                    })
                })
        }

        const confirmDeleteTicket = async id => {
            const result = context.root.$swal({
                icon: 'info',
                title: 'System Info',
                text: 'Are you sure you want to delete the this Ticket?',
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'Yes, delete it!',
                cancelButtonText: 'No, cancel',
                customClass: {
                    confirmButton: 'btn btn-info',
                    cancelButton: 'btn btn-danger ml-2', // Optional: Customize the cancel button class
                },
                buttonsStyling: true,
            }).then(result => {
                if (result.value) {
                    removeTicket(id)
                } else {
                    context.root.$swal({
                        icon: 'info',
                        title: 'Cancelled',
                        text: 'Your Ticket is safe you cancell deletion of it',
                        showConfirmButton: true,
                        customClass: {
                            confirmButton: 'btn btn-info',
                        },
                        buttonsStyling: true,
                    })
                }
            })
        }

        const removeTicket = async id => {
            await store.dispatch('cromis-short_haul/removeTicket', id)
                .then(response => {
                    refetch()
                })
                .catch(error => {
                    context.root.$swal({
                        icon: 'error',
                        title: 'Server Error',
                        text: 'Something went wrong. See tech support',
                        showConfirmButton: true,
                        customClass: {
                            confirmButton: 'btn btn-danger',
                        },
                        buttonsStyling: true,
                    })
                })
        }

        return {
            // Data
            selections,
            formSelections,
            levels,
            children,
            transporter,
            long_haul,
            fetch,
            columns,
            perPage,
            currentPage,
            totalRecords,
            from,
            to,
            meta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            records,
            refetch,
            changeFormSelection,
            // Methods
            required,
            saving,
            serverErrors,
            dataForm,
            myModal,
            myModalTransport,
            myModalTicket,
            locationFilter,
            invokeCreateForm,
            invokeUpdateForm,
            submit,
            submitTransports,
            isFormValid,
            handleCreate,
            handleUpdate,
            remove,
            confirmDelete,
            transporters,
            transporterDrivers,
            drivers,
            fleets,
            routes,
            warehouses,
            changeSource,
            changeDestination,
            findRoute,
            selectedDriver,
            selectedCompany,
            destinations,
            sales,
            transports,
            markets,
            invokeFleetsForm,
            societies,
            tikets,
            totalWeight,
            tValue,
            viewTickets,
            requestDevice,
            weight,
            device,
            parseWeightData,
            tfDetails,
            confirmDeleteTicket,
            removeTicket,
            trailers,
            addElement,
            removeRow,
            printPdf,
            isItemSelected,
            checkboxToggled,
            toggleCheckAll,
            generateReport,
        }
    },
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';
</style>
